import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkAuthSession } from '../../redux/action/auth';

/**
 * SessionChecker component that checks session expiration on app initialization
 * This ensures that whenever a user visits the website, their session is validated
 * and storage is cleared if the session has expired.
 */
const SessionChecker = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Check session whenever the component mounts (app initialization)
    const verifySession = async () => {
      try {
        await dispatch(checkAuthSession());
      } catch (error) {
        console.error('Session check failed on app initialization:', error);
      }
    };

    verifySession();
  }, [dispatch]);

  // This component doesn't render anything
  return null;
};

export default SessionChecker;

